<template>
  <span :class="className">{{ tempoFormatadoContador }}</span>
</template>

<script>
import moment from 'moment-timezone'

export default {
    name: 'ContagemRegressiva',
    props: {
        dataExpiracao: {
            type: String,
            required: true
        },
        className: {
            type: String,
            default: 'base-timer-label'
        }
    },
    data() {
        return {
            tempoRestante: 0,
            intervalId: null
        }
    },
    mounted() {
        if (this.dataExpiracao) {
            this.calcularTempoRestante()
            this.iniciarTempo()
        }
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
    computed: {
        tempoFormatadoContador() {
            return this.formatarTempoData(this.tempoRestante)
        }
    },
    methods: {
        iniciarTempo() {
            this.intervalId = setInterval(() => {
                this.calcularTempoRestante()

                if (this.tempoRestante <= 0) {
                    this.tempoRestante = 0
                    this.$emit('cronometroZerado')
                    clearInterval(this.intervalId)
                }
            }, 1000)
        },
        calcularTempoRestante() {
            const tz = this.$store.state.comum.timezone

            const agora = moment.tz(tz)
            const expiracao = moment.tz(this.dataExpiracao, 'YYYY-MM-DDTHH:mm:ss', tz)

            this.tempoRestante = expiracao.diff(agora)
        },
        formatarTempoData(tempoMs) {
            const duracao = moment.duration(tempoMs)

            let days = Math.floor(duracao.asDays())
            let hours = duracao.hours()
            let minutes = duracao.minutes()
            let seconds = duracao.seconds()

            if (hours < 10) hours = '0' + hours
            if (minutes < 10) minutes = '0' + minutes
            if (seconds < 10) seconds = '0' + seconds

            if (days > 0) return `${days}d ${hours}:${minutes}:${seconds}`
            if (hours > 0) return `${hours}:${minutes}:${seconds}`
            return `${minutes}:${seconds}`
        }
    }
}
</script>

<style scoped lang="stylus">
.base-timer-label
  font-size 14px
  color white
</style>